/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CostBucketTotals,
    CostBucketTotalsFromJSON,
    CostBucketTotalsFromJSONTyped,
    CostBucketTotalsToJSON,
} from './CostBucketTotals';
import {
    CostBucketTotalsDiscount,
    CostBucketTotalsDiscountFromJSON,
    CostBucketTotalsDiscountFromJSONTyped,
    CostBucketTotalsDiscountToJSON,
} from './CostBucketTotalsDiscount';
import {
    CostBucketTotalsFee,
    CostBucketTotalsFeeFromJSON,
    CostBucketTotalsFeeFromJSONTyped,
    CostBucketTotalsFeeToJSON,
} from './CostBucketTotalsFee';
import {
    CostBucketTotalsItems,
    CostBucketTotalsItemsFromJSON,
    CostBucketTotalsItemsFromJSONTyped,
    CostBucketTotalsItemsToJSON,
} from './CostBucketTotalsItems';
import {
    CostBucketTotalsTax,
    CostBucketTotalsTaxFromJSON,
    CostBucketTotalsTaxFromJSONTyped,
    CostBucketTotalsTaxToJSON,
} from './CostBucketTotalsTax';
import {
    CostBucketTotalsTotal,
    CostBucketTotalsTotalFromJSON,
    CostBucketTotalsTotalFromJSONTyped,
    CostBucketTotalsTotalToJSON,
} from './CostBucketTotalsTotal';

/**
 * Summary of each of the line item buckets.
 * @export
 * @interface CostBreakdownBucketTotals
 */
export interface CostBreakdownBucketTotals {
    /**
     * 
     * @type {CostBucketTotalsFee}
     * @memberof CostBreakdownBucketTotals
     */
    fee: CostBucketTotalsFee;
    /**
     * 
     * @type {CostBucketTotalsItems}
     * @memberof CostBreakdownBucketTotals
     */
    items: CostBucketTotalsItems;
    /**
     * 
     * @type {CostBucketTotalsTax}
     * @memberof CostBreakdownBucketTotals
     */
    tax: CostBucketTotalsTax;
    /**
     * 
     * @type {CostBucketTotalsDiscount}
     * @memberof CostBreakdownBucketTotals
     */
    discount: CostBucketTotalsDiscount;
    /**
     * 
     * @type {CostBucketTotalsTotal}
     * @memberof CostBreakdownBucketTotals
     */
    total: CostBucketTotalsTotal;
}

export function CostBreakdownBucketTotalsFromJSON(json: any): CostBreakdownBucketTotals {
    return CostBreakdownBucketTotalsFromJSONTyped(json, false);
}

export function CostBreakdownBucketTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostBreakdownBucketTotals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fee': CostBucketTotalsFeeFromJSON(json['fee']),
        'items': CostBucketTotalsItemsFromJSON(json['items']),
        'tax': CostBucketTotalsTaxFromJSON(json['tax']),
        'discount': CostBucketTotalsDiscountFromJSON(json['discount']),
        'total': CostBucketTotalsTotalFromJSON(json['total']),
    };
}

export function CostBreakdownBucketTotalsToJSON(value?: CostBreakdownBucketTotals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fee': CostBucketTotalsFeeToJSON(value.fee),
        'items': CostBucketTotalsItemsToJSON(value.items),
        'tax': CostBucketTotalsTaxToJSON(value.tax),
        'discount': CostBucketTotalsDiscountToJSON(value.discount),
        'total': CostBucketTotalsTotalToJSON(value.total),
    };
}

